import { goPage } from "../system/coords";
import { useDispatch } from "react-redux";

import CodeWall from "./examples/CodeWall";
import CanvasDraw from "./examples/CanvasDraw";
import QrCodeInput from "./examples/QrCodeInput";
import TimeBlocks from "./examples/TimeBlocks";
import TimeDonut from "./examples/TimeDonut";
import LightAnimation from "./examples/LightAnimation";
import FilteredImage from "./examples/FilteredImage";
import ForecastChart from "./examples/ForecastChart";

import { setPageName } from "../redux/actions";

const ArrowIcon = "/assets/images/arrow.svg";

const Example = props => {
  let { comingSoon } = props;
  const { color, blank } = props;
  let className = "Example";

  if (color) {
    className += ` ${color}`;
  }

  if (blank) {
    className += " notDesktopHide";
  }

  if (comingSoon) {
    className += " notDesktopHide";
    comingSoon = <div style={{ paddingTop: "135px", color: "rgba(255, 255, 255, 0.3" }}>Coming Soon</div>;
  }

  return (
    <div className={className} style={blank ? { pointerEvents: "none" } : {}}>
      {props.children ?? comingSoon}
    </div>
  );
};

const DemosContent = () => {
  const dispatch = useDispatch();

  return (
    <>
      <div className="Demos center full-height">
        <div className="examples">
          <img
            src={ArrowIcon}
            className="Arrow-icon Arrow-Demos notDesktopHide"
            alt="Go to next page"
            onClick={() => {
              goPage("Contact");
              dispatch(setPageName("Contact"));
            }}
          />
          <div
            style={{
              position: "relative",
              overflowY: "auto",
              height: "100%",
              width: "100%",
              top: "0px",
              left: "0px",
            }}
            className="scrollableExamples"
          >
            <Example comingSoon="" color="" blank="true" />
            <Example comingSoon="" color="" blank="true" />
            <Example comingSoon="" color="">
              <TimeDonut />
            </Example>
            <Example comingSoon="" color="blue">
              <CanvasDraw />
            </Example>
            <br />

            <Example comingSoon="" color="" blank="true" />
            <Example comingSoon="" color="green-very-dark">
              <ForecastChart />
            </Example>
            <Example comingSoon="" color="">
              <LightAnimation />
            </Example>
            <Example comingSoon="" color="orange">
              <QrCodeInput />
            </Example>
            <br />

            <Example comingSoon="" color="">
              <CodeWall />
            </Example>
            <Example comingSoon="" color="grey">
              <FilteredImage />
            </Example>
            <Example comingSoon="" color="">
              <TimeBlocks />
            </Example>
            <Example comingSoon="" color="" blank="true" />
          </div>
        </div>
      </div>
    </>
  );
};

export default DemosContent;
